/**
 * @generated SignedSource<<524353d5d570257b21c6913412fa2ed7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksUseAcquisitionPopupQuery",
  "selections": [{
    "alias": "widgetConfig",
    "args": [{
      "kind": "Literal",
      "name": "filter",
      "value": {
        "entityId": "scmp_pwa_widget"
      }
    }],
    "concreteType": "AppConfig",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "json",
      "storageKey": null
    }],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_widget\"})"
  }],
  "type": "Query",
  "abstractKey": null
};
node.hash = "e9738b90264ec450dc22909225ffbc57";
export default node;